export default __webpack_public_path__ + "assets/images/Payment_02.655517.webp";